// Hero background — plays the rotating-globe MP4 served from /api/media/globe-bg.mp4.
// If the video fails to load (404 / network / codec), gracefully falls back to the
// interactive 3D globe (react-globe.gl) — never shows a broken state.
import { useState } from "react";
import GlobeHero from "@/components/GlobeHero";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const GLOBE_VIDEO = `${BACKEND_URL}/api/media/globe-bg.mp4`;

export default function HeroVideo({ height = 560 }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <GlobeHero height={height} />;
  }

  return (
    <div
      data-testid="hero-globe"
      className="relative w-full overflow-hidden rounded-3xl"
      style={{ height, background: "#05080F" }}
    >
      <video
        src={GLOBE_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
        onError={(e) => {
          const code = e?.currentTarget?.error?.code;
          if (code === 1) return; // MEDIA_ERR_ABORTED — ignore
          // eslint-disable-next-line no-console
          console.warn("[HeroVideo] fallback to 3D globe — error code:", code);
          setFailed(true);
        }}
      />
      {/* vignette to blend into the page */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(circle at 50% 50%, transparent 50%, rgba(10,15,26,0.55) 82%, #08060F 100%)",
        }}
      />
      {/* faint cyan glow ring */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          boxShadow: "inset 0 0 140px rgba(0, 229, 255, 0.20)",
          borderRadius: "1.5rem",
        }}
      />
    </div>
  );
}
